/**
 * Created by pawella on 2017-04-29.
 */
window._cmsMceConfig = {
    verify_html : false
};